import { render, staticRenderFns } from "./BrandsSlider.vue?vue&type=template&id=b5539424&"
import script from "./BrandsSlider.vue?vue&type=script&lang=js&"
export * from "./BrandsSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports